import { TAGS, TAGS_PAGINATE, TAGS_IN_BANNER, TAG_CREATE,
  TAGS_ENABLE, TAGS_DISABLE, TAGS_EXCLUDE, NOTIFICATIONS_INCLUDE } from '@store/types'
import axios from 'axios'
import shortly from 'vuex-shortly'
import graphQL from '@graphQL'
import TagsQuery from '@graphQL/queries/Tags'
import TagListQuery from '@graphQL/queries/TagList'

const state = {
  tags: [],
  paginate: {}
}

const getters = {
  [TAGS]: 'tags',
  [TAGS_PAGINATE]: 'paginate'
}

const mutations = {
  [TAGS]: (state, payload) => {
    state.tags = payload
  },
  [TAGS_PAGINATE]: 'paginate',
  [TAG_CREATE]: (state, payload) => {
    if (!state.tags.some(tag => tag.name === payload.name)) {
      state.tags = [ payload, ...state.tags ]
    }
  }
}

const actions = {
  [TAGS]: async ({ commit }, payload = {}) => {
    try {
      const response = await graphQL(TagsQuery, payload)
      const { data: tags, ...paginate } = response?.data?.data?.tags || {}

      commit(TAGS, tags)
      commit(TAGS_PAGINATE, paginate)
      return true
    } catch (error) {
      return false
    }
  },

  [TAGS_IN_BANNER]: async ({ commit }) => {
    const response = await graphQL(TagListQuery, { in_media: true })
    const result = response?.data?.data?.tagList || []

    return (result.length && result) || []
  },

  [TAG_CREATE]: async ({ commit, dispatch }, formData) => {
    try {
      const response = await axios.post('/tag', formData)

      dispatch(NOTIFICATIONS_INCLUDE, {
        type: 'success',
        message: 'Tags criadas com sucesso!'
      })
      commit(TAG_CREATE, response.data.data)

      return response
    } catch (err) {
      dispatch(NOTIFICATIONS_INCLUDE, Error('Não foi possível criar as tags'))
    }
  },

  [TAGS_ENABLE]: async ({ dispatch }, payload) => {
    try {
      const items = payload.map(item => item.id)
      const response = await axios.post('/tag/action', {
        action: 'enable',
        items
      })

      await dispatch(TAGS)

      dispatch(NOTIFICATIONS_INCLUDE, {
        type: 'success',
        message: 'Tag(s) habilitada(s) com sucesso!'
      })

      return response
    } catch (err) {
      dispatch(NOTIFICATIONS_INCLUDE, Error('Não foi possível ativar a(s) tag(s)'))
    }
  },

  [TAGS_DISABLE]: async ({ dispatch }, payload) => {
    try {
      const items = payload.map(item => item.id)
      const response = await axios.post('/tag/action', {
        action: 'disable',
        items
      })

      await dispatch(TAGS)

      dispatch(NOTIFICATIONS_INCLUDE, {
        type: 'success',
        message: 'Tag(s) desabilitada(s) com sucesso!'
      })

      return response
    } catch (err) {
      dispatch(NOTIFICATIONS_INCLUDE, Error('Não foi possível desabilitar a(s) tag(s)'))
    }
  },

  [TAGS_EXCLUDE]: async ({ dispatch }, payload) => {
    try {
      const items = payload.map(item => item.id)
      const response = await axios.post('/tag/action', {
        action: 'delete',
        items
      })
      await dispatch(TAGS)

      dispatch(NOTIFICATIONS_INCLUDE, {
        type: 'success',
        message: 'Tag(s) excluída(s) com sucesso!'
      })

      return response
    } catch (err) {
      dispatch(NOTIFICATIONS_INCLUDE, Error('Não foi possível excluir a(s) tag(s)'))
    }
  }
}

export default shortly({ state, getters, mutations, actions })



// WEBPACK FOOTER //
// ./src/store/modules/tags.js